module.exports = __webpack_public_path__ + "media/styles/images/svg/ex-red-6ecab6815c230559e88f68b5ae54e3ec.svg";